<script>
  import Router from 'svelte-spa-router'
  import Header from "./componants/header.svelte";
  import Footer from "./componants/footer.svelte"
  import Home from './routes/Home.svelte';
  import Todo from './routes/Todo.svelte';
  import View from './routes/View.svelte'
  import Accessibility from './routes/Accessibiliity.svelte'
  import Contact from './routes/Contact.svelte';
  import Book from './routes/Book.svelte';
  import Mobilemenu from './componants/mobilemenu.svelte';
  

const routes = {
    
  '/': Home,
  '/View': View,
  '/Accessibility': Accessibility,
  '/Contact':Contact,
  '/Book':Book,
  '/Todo': Todo,
  '*': Home
}
</script>
<Mobilemenu />
<Header />

<nav>
  <ul>
    <li><a href='#/Home'>Home</a></li>
    <li><a href='#/View'>View</a></li>
    <li><a href='#/Accessibility'>Accessibility</a></li>
    <li><a href="#/Contact">Contact</a></li>
    <li><a href="#/Book">Book</a></li>
    <li><a href='#/Todo'>To do</a></li>
</ul>
</nav>

<main>
  <Router {routes}/>
</main>

<Footer />
<style>
	main {
		text-align: center;
		width: 100%;
		margin:auto;
	}
  nav{
        display: flex;
        justify-content: center;
        width:100%;
        
    }

    li{
        background-color: #cbad81;
        margin: 12px;
        border-radius: 5px 25px 0 30px;
        padding: 5px 15px 5px 15px;
        color: #78A7BD;    
    }
    li:hover{
        background-color: #e8d1af;
    }
    ul{
        display: flex;
    flex-direction: row;
    justify-items: center;
    }
    
    a{
        text-decoration: none;
        color: #ffffff;
        margin: 15px 0 15px 0;
    }
    @media screen and (max-width: 800px) {
       nav{
        display: none;
       }
       main{
        width: 100%;
       }
    }


	
</style>